function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeStepsStepTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1317,
    height: 79.51,
    viewBox: "0 0 1317 79.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 0.51,
    width: 1317,
    height: 79,
    style: {
      fill: "#fff",
      fillOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.39 79.07 0.14 79.07 26.94 39.53 0.14 0 245.39 0 272.19 39.53 245.39 79.07",
    style: {
      fill: "#e06b30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.77,49.84A9.8,9.8,0,0,1,81,58q-3.75,3-10.37,3a24.8,24.8,0,0,1-10.82-2V53a29.39,29.39,0,0,0,5.67,2,23.91,23.91,0,0,0,5.58.72c2.52,0,4.39-.48,5.58-1.44a4.71,4.71,0,0,0,1.8-3.86,4.84,4.84,0,0,0-1.65-3.71c-1.1-1-3.38-2.21-6.82-3.6a18.56,18.56,0,0,1-7.52-5,10.47,10.47,0,0,1-2.18-6.66,9.33,9.33,0,0,1,3.44-7.7q3.42-2.8,9.3-2.8a27.19,27.19,0,0,1,11.12,2.4l-2,5.19a24.39,24.39,0,0,0-9.28-2.18,7.12,7.12,0,0,0-4.72,1.35,4.44,4.44,0,0,0-1.6,3.55,5.12,5.12,0,0,0,.64,2.6,6.41,6.41,0,0,0,2.11,2,35.54,35.54,0,0,0,5.28,2.53,29.37,29.37,0,0,1,6.29,3.33,10.09,10.09,0,0,1,2.93,3.49A10.56,10.56,0,0,1,84.77,49.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.77,60.42H99.4V26.92H87.94V21.46h29.29v5.46H105.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.24,60.42h-22v-39h22V26.8H129.57V37.45h14.68v5.33H129.57V55.05h15.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.46,33.24q0,6.09-4,9.35t-11.38,3.25H160V60.42h-6.37v-39h11.22q7.31,0,10.94,3T179.46,33.24ZM160,40.48h3.38c3.27,0,5.67-.56,7.2-1.7a6.18,6.18,0,0,0,2.29-5.33,6,6,0,0,0-2-5c-1.37-1.1-3.51-1.65-6.4-1.65h-4.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.06,60.42H210.8V35.26q0-4.5.21-7.14c-.41.42-.91.9-1.5,1.41s-2.59,2.15-6,4.9l-3.14-4,11.46-9h5.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "506.72 79.07 261.47 79.07 288.28 39.53 261.47 0 506.72 0 533.53 39.53 506.72 79.07",
    style: {
      fill: "#e06b30"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.26,49.84A9.8,9.8,0,0,1,336.5,58q-3.75,3-10.36,3a24.66,24.66,0,0,1-10.82-2V53A29.07,29.07,0,0,0,321,55a23.91,23.91,0,0,0,5.58.72c2.53,0,4.4-.48,5.59-1.44a4.71,4.71,0,0,0,1.8-3.86,4.83,4.83,0,0,0-1.66-3.71q-1.65-1.51-6.82-3.6Q320.15,41,318,38.18a10.4,10.4,0,0,1-2.19-6.66,9.33,9.33,0,0,1,3.47-7.68,14.51,14.51,0,0,1,9.3-2.84,27.22,27.22,0,0,1,11.18,2.31l-2,5.19a24.38,24.38,0,0,0-9.27-2.18,7.09,7.09,0,0,0-4.73,1.35,4.38,4.38,0,0,0-1.6,3.55,4.92,4.92,0,0,0,.64,2.6,6.47,6.47,0,0,0,2.1,2,35.75,35.75,0,0,0,5.28,2.57,28.28,28.28,0,0,1,6.29,3.33,9.79,9.79,0,0,1,2.93,3.49A10.55,10.55,0,0,1,340.26,49.84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.26,60.42h-6.37V26.92H343.43V21.46h29.29v5.46H361.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.72,60.42h-22v-39h22V26.8H385.06V37.45h14.66v5.33H385.06V55.05h15.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,33.24q0,6.09-4,9.35t-11.38,3.25h-4.05V60.42h-6.38v-39h11.22q7.31,0,10.94,3T435,33.24Zm-19.43,7.24h3.39c3.27,0,5.67-.56,7.19-1.7a6.22,6.22,0,0,0,2.3-5.33,6,6,0,0,0-2.06-5Q424.29,26.8,420,26.8h-4.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.58,60.42H454.14V55.68l10-10.11a86,86,0,0,0,5.91-6.46,15.46,15.46,0,0,0,2.09-3.58,9.66,9.66,0,0,0,.67-3.6,5.5,5.5,0,0,0-1.58-4.16,6.08,6.08,0,0,0-4.39-1.52,11.7,11.7,0,0,0-4.33.83,20.7,20.7,0,0,0-4.84,3L454.31,26a22.15,22.15,0,0,1,6.38-3.87A18.62,18.62,0,0,1,467.21,21a12.86,12.86,0,0,1,8.72,2.83,9.64,9.64,0,0,1,3.28,7.64,13.39,13.39,0,0,1-1,5,20.63,20.63,0,0,1-2.9,4.89,66.48,66.48,0,0,1-6.54,6.78L462,54.69V55h18.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "767.05 79.07 521.8 79.07 548.61 39.53 521.8 0 767.05 0 793.86 39.53 767.05 79.07",
    style: {
      fill: "#8e8c99"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.78,44.21V59.82H565.4V20.76h11q7.56,0,11.2,2.83t3.63,8.55q0,7.29-7.59,10.39l11,17.29h-7.27l-9.35-15.61Zm0-5.29h4.44q4.46,0,6.47-1.65a6,6,0,0,0,2-4.92,5.28,5.28,0,0,0-2.16-4.75q-2.17-1.46-6.52-1.45h-4.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.47,59.82h-22.1V20.76h22.1v5.39H606.76V36.79h14.72v5.34H606.76V54.4h15.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.17,20.76h6.63L646.12,59.82h-6.74L625.76,20.76h6.57L640.48,45c.43,1.16.88,2.65,1.36,4.48s.79,3.18.94,4.07c.23-1.35.59-2.92,1.07-4.7s.87-3.1,1.17-4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,59.82V20.76h6.39V59.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.75,59.82h-22.1V20.76h22.1v5.39H688V36.79h14.72v5.34H688V54.4h15.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M748.24,59.82h-7l-6.62-23.3c-.29-1-.65-2.48-1.07-4.4s-.69-3.24-.78-4q-.27,1.71-.87,4.44c-.4,1.81-.73,3.17-1,4.06l-6.47,23.19h-6.94l-5-19.56-5.13-19.5h6.52l5.58,22.76a98.25,98.25,0,0,1,1.87,9.67c.2-1.51.49-3.2.88-5.07s.75-3.39,1.07-4.55l6.36-22.81H736l6.52,22.92a83.07,83.07,0,0,1,2,9.51,70.82,70.82,0,0,1,1.92-9.72L752,20.76h6.47Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeStepsStepTwo);
export default __webpack_public_path__ + "static/media/three-steps-step-two.553d3c70e6afebfcabab57886572b0a5.svg";
export { ForwardRef as ReactComponent };